import {
  Measure
} from '../../common/measure';
import {
  DIM2CLASS
} from '../../core/icon-class';

require('./stat-header.component.scss');

class StatHeaderController {
  constructor(
    $scope,
    CurrentFilterService,
    RouterService,
    $element,
    $timeout,
    CurrentModelService,
    LayoutService,
  ) {
    this.$scope = $scope;
    this.$element = $element;
    this.$timeout = $timeout;
    this.$scope.list = [];
    this.LayoutService = LayoutService;
    this.Measure = Measure;
    // this.getMeasure = Measure.getMeasure;
    // this.getMeasureLabel = Measure.getMeasureLabel;
    // this.getMeasures = Measure.getMeasures;
    this.totalElements = 'total_elements';
    this.DIM2CLASS = DIM2CLASS;
    this.CurrentFilterService = CurrentFilterService;
    this.CurrentModelService = CurrentModelService;
    this.router = RouterService;
    this.CurrentFilterService.rebuildVisibleDimensions();

  }

  getMeasureLabel(measure) {
    if (measure === this.totalElements) return gettext('Всего');
    return this.Measure.getMeasureLabel(measure);
  }

  getMeasures() {
    if (this.filter.isSummStat) return [this.totalElements].concat(this.Measure.getMeasures());
    return this.Measure.getMeasures();
  }

  get isShowAddDimensionBtn() {
    return !this.LayoutService.drilldownMax || this.filter.drilldown.length < this.LayoutService.drilldownMax;
  }

  get isReadOnly() {
    if (this.router.isFilterEditModal) return false;
    return this.CurrentFilterService.filter.isDashboard ||
      this.CurrentFilterService.filter.isCard;
  }

  scrollToEnd() {
    this.$timeout(() => {
      const parentEl = this.$element.closest('.sc-view-container');
      if (parentEl[0]) parentEl.scrollLeft(parentEl[0].scrollWidth);
    }, 10);
  }

  selectDim(dim) {
    if (this.router.isFilterEditModal) {
      if (this.filter.hasDrilldown(dim.toString())) {
        return;
      }
      this.filter.addDrilldown(dim.toString());
      // this.filter.changed();
      this.$onChanges(this);
    } else this.router.selectDim(dim);
  }

  replaceDim(newDim, oldDim) {
    if (this.router.isFilterEditModal) {
      if (this.filter.hasDrilldown(newDim.toString())) {
        return;
      }
      this.filter.replaceDrilldown(newDim.toString(), oldDim.toString());
      // this.filter.changed();
      this.$onChanges(this);
    } else this.router.replaceDim(newDim, oldDim);
  }

  setMeasure(measure) {
    if (this.router.isFilterEditModal) this.filter.measure = measure;
    else this.router.setMeasure(measure);
  }

  removeDim(dim) {
    if (this.router.isFilterEditModal) {

      if (!this.filter.hasDrilldown(dim.toString())) {
        return;
      }
      this.filter.removeDrilldown(dim.toString());
      this.$onChanges(this);
      // this.filter.changed();
      // this.filterChanged();
    } else this.router.removeDim(dim);
  }

  get showRemove() {
    const drillList = this.$scope.list.filter(item => item.isDrill);
    return drillList && drillList.length > 1;
  }

  get test() {
    // console.log(this);
    return true;
  }

  get visibleDimensions() {
    return this.CurrentFilterService.visibleDimensions;
  }

  get model() {
    return this.CurrentModelService.model;
  }

  toggleSortDirs(columnName) {
    if (this.isReadOnly) return;
    const colOrders = columnName.split(',');
    const filter = this.filter;
    for (let i = 0; i < filter.orders.length; i++) {
      let j = 0;
      if (colOrders.every(o => {
          const res = o === filter.orders[i + j];
          j++;
          return res;
        })) {
        const dir = filter.orderDirs[i];
        if (dir === 'asc') {
          colOrders.map((o, j) => filter.orderDirs[i + j] = 'desc');
        } else {
          filter.orders.splice(i, colOrders.length);
          filter.orderDirs.splice(i, colOrders.length);
        }
      }
    }
  }

  toggleSortDrillSorterOrder(drill) {
    if (this.isReadOnly) return;

    const filter = this.filter;
    if (!filter.orders || !filter.orderDirs) {
      filter.orders = [];
      filter.orderDirs = [];
    }
    if (!filter.hasOwnProperty('orders')) {
      filter.orders = angular.copy(filter.orders);
    }
    if (!filter.hasOwnProperty('orderDirs')) {
      filter.orderDirs = angular.copy(filter.orderDirs);
    }

    const columnName = this.getOrderColumnName(drill);
    if (filter.orders.join(',').indexOf(columnName) === -1) {
      filter.orders = filter.orders.concat(columnName.split(','));
      filter.orderDirs = filter.orderDirs.concat(columnName.split(',').map(o => 'asc'));
    } else {
      this.toggleSortDirs(columnName);
    }
    filter.orders = angular.copy(filter.orders);
    filter.orderDirs = angular.copy(filter.orderDirs);

    if (this.router.isFilterEditModal) this.filterData.update(filter);
    this.router.filter = filter;
  }

  toggleSortMeasureSorterOrder() {
    if (this.isReadOnly) return;
    const filter = this.filter;
    if (!filter.hasOwnProperty('orders')) {
      filter.orders = angular.copy(filter.orders);
    }
    if (!filter.hasOwnProperty('orderDirs')) {
      filter.orderDirs = angular.copy(filter.orderDirs);
    }

    const columnName = 'measure';
    if (!filter.orders.includes(columnName)) {
      filter.orders.push(columnName);
      filter.orderDirs.push('asc');
    } else {
      const sortIndex = this.getMeasureOrderDirIndex();
      const sortDir = this.getMeasureSortDir();
      if (sortDir === 'desc') {
        filter.orders.splice(sortIndex, 1);
        filter.orderDirs.splice(sortIndex, 1);
      } else {
        filter.orderDirs[sortIndex] = 'desc';
      }
    }
    filter.orders = angular.copy(filter.orders);
    filter.orderDirs = angular.copy(filter.orderDirs);

    if (this.router.isFilterEditModal) this.filterData.update(filter);
    else this.router.filter = filter;

  }

  isSortable(drill) {
    const columnName = this.getOrderColumnName(drill);
    const filter = this.filter;
    return filter.orders && filter.orders.join(',').includes(columnName);
  }


  isMesureSortable() {
    const filter = this.filter;
    const columnName = 'measure';
    if (!filter || !filter.measure || filter.measure === this.totalElements) {
      return false;
    }
    return filter.orders && filter.orders.includes(columnName);
  }

  getSortDir(drill) {
    const sortIndex = this.getOrderDirIndex(drill);
    if (sortIndex === -1) return 'none';
    return this.filter.orderDirs[sortIndex];
  }

  getMeasureSortDir() {
    const sortIndex = this.getMeasureOrderDirIndex();
    if (sortIndex === -1) {
      return null;
    }
    return this.filter.orderDirs[sortIndex];
  }

  getOrderDirIndex(drill) {
    const filter = this.filter;
    const columnOrders = this.getOrderColumnName(drill).split(',');

    const sortIndex = filter.orders.findIndex((e, i) =>
      columnOrders.every((o, j) => filter.orders[i + j] === columnOrders[j]));
    return sortIndex;
  }

  getMeasureOrderDirIndex() {
    const filter = this.filter;
    const columnName = 'measure';
    if (!filter) {
      return -1;
    }
    const sortIndex = filter.orders.findIndex(e => e === columnName);
    return sortIndex;
  }

  getOrderColumnName(drill) {
    const dimension = this.CurrentModelService.model.getDimensionParts(drill);
    if (
      dimension.hierarchy.name === 'ym' ||
      dimension.hierarchy.name === 'ymd' ||
      dimension.hierarchy.name === 'ymdh' ||
      dimension.hierarchy.name === 'ymdhm'
    )
      return dimension.hierarchy.levels.map(l => `${dimension.dimension.name}.${l}`).join(',');
    return `${dimension.dimension.name}.${dimension.level.label_attribute}`;
  }

  dropMove(index) {
    this.$scope.list.splice(index, 1);
    const filter = this.filter;
    filter.drilldown = [];
    const newDrills = this.$scope.list.filter(item => item.isDrill).map(item => item.key);
    filter.drilldown.splice(0, filter.drilldown.length, ...newDrills);
    if (this.router.isFilterEditModal) this.filterData.update(filter);
    else this.router.filter = filter;
  }

  $onChanges(changesObj) {
    const currentValue = this.router.isFilterEditModal ? this.filter : changesObj.filter.currentValue;
    if (changesObj.filter && currentValue) {

      const newDrillsList = currentValue.drilldown.slice().map(item => {
        return {
          key: item,
          label: this.model.getDrillLabel(item),
          isDrill: true,
        };
      });
      // const staticItems = [{
      //     isDrill: false
      //   },
      //   {
      //     isDrill: false
      //   }
      // ];
      // this.$scope.list = staticItems.concat(newDrillsList);
      this.$scope.list = newDrillsList;
    }
  }
}

export function StatHeaderComponent(
  CurrentFilterService,
  RouterService,
  CurrentModelService,
) {
  return {
    template: require('./stat-header.component.html'),
    restrict: 'A',
    scope: {
      //      list: [],
      // readOnly: '<',
    },
    bindToController: {
      filter: '<',
      filterData: '<',
    },
    controller: StatHeaderController,
    controllerAs: '$ctrl',
  };
}



// WEBPACK FOOTER //
// ./src/stat/stat-header/stat-header.component.js